// extracted by mini-css-extract-plugin
export default {"navWp":"index_navWp_9IlOP","nav":"index_nav_yF7ju","main":"index_main_GM5Wh","sub":"index_sub_Y7ydt"};